import React from 'react';

import clsxm from '@/utils/clsxm';

interface Props {
  number?: number;
  currentTab: boolean;
}

export const PastilleNumber: React.FC<Props> = ({ number, currentTab }) => {
  return (
    <div
      className={clsxm(
        currentTab ? 'bg-white text-black' : number && number >= 1 ? 'bg-red-500 text-white' : 'bg-gray-300 text-white',
        'rounded-full p-2 text-[9.5px] w-7 h-7 items-center text-center flex justify-center font-extrabold'
      )}
    >
      {number || '0'}
    </div>
  );
};
